import { useScrollReveal } from "@/hooks/useScrollReveal";

const stats = [
  {
    percentage: "98%",
    label: "de clientes satisfeitas",
    detail:
      "Índice de satisfação consistentemente alto, construído com dedicação e resultados reais.",
    highlight: "Excelência comprovada",
  },
  {
    percentage: "+1000",
    label: "atendimentos realizados",
    detail:
      "Experiência consolidada em tratamentos faciais e design de sobrancelhas com técnicas exclusivas.",
    highlight: "Histórico de confiança",
  },
];

export default function AboutSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.15 });

  return (
    <section id="sobre" className="py-20 md:py-32 bg-background-50">
      <div
        ref={ref}
        className={`max-w-4xl mx-auto px-6 md:px-10 transition-all duration-1000 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <p className="flex items-center gap-3 font-label text-[11px] md:text-xs uppercase tracking-[0.3em] text-primary-600 mb-6">
          <span className="w-10 h-[1px] bg-primary-500/60" />
          Conheça a especialista
        </p>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-8">
          A arte de{" "}
          <span className="italic font-normal text-primary-600">realçar</span>{" "}
          sua beleza
          <span className="block font-heading text-lg md:text-xl text-foreground-500 font-normal mt-3">
            com ciência, sensibilidade e propósito
          </span>
        </h2>

        <div className="space-y-5 text-foreground-700 leading-relaxed text-sm md:text-base font-light">
          <p>
            Há mais de 6 anos dedicada à beleza e ao bem-estar, Jennifer
            Siqueira construiu uma reputação de excelência em Blumenau.
            Especialista em tratamentos faciais e design de sobrancelhas, sua
            abordagem une técnicas modernas com um olhar humano e sensível.
          </p>
          <p>
            Cada atendimento começa com uma escuta atenta. Para Jennifer,
            entender a história da sua pele e seus objetivos é o primeiro
            passo para criar um protocolo verdadeiramente personalizado. Nada
            de fórmulas prontas — aqui, cada cliente é única.
          </p>
          <p>
            Em constante atualização com as tendências do mercado da beleza,
            Jennifer aprimora suas técnicas e protocolos para entregar sempre o
            melhor atendimento, com qualidade e cuidado em cada detalhe, trazendo
            para Blumenau o que há de mais inovador em cuidados com a pele e
            sobrancelhas.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-10">
          {stats.map((stat) => (
            <div
              key={stat.percentage}
              className="bg-background-100 border border-background-200 rounded-2xl p-6 md:p-7 flex flex-col justify-between"
            >
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-primary-600 mb-2">
                  {stat.percentage}
                </p>
                <p className="text-sm font-label text-foreground-800 font-medium mb-3">
                  {stat.label}
                </p>
                <p className="text-xs text-foreground-500 font-light leading-relaxed">
                  {stat.detail}
                </p>
              </div>
              <p className="text-xs font-heading italic text-primary-700 mt-5 pt-4 border-t border-background-200">
                {stat.highlight}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}